import { withAsyncLoading } from '../../../lib/PST.Web.Common/src/hocs/withAsyncPageLoading/withAsyncPageLoading';

const LoadableFormationDetailsQuizPage = withAsyncLoading(async () => import('./FormationDetailsQuizPage').then((res) => res.FormationDetailsQuizPage));

export { LoadableFormationDetailsQuizPage };
